module.exports = "/virtual-football-league/img/amblems/right/logos/EIBAR.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/EIBAR.png
// module id = 2170
// module chunks = 4